import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { setSupabaseClient } from '@lura/shared'
import { supabase } from '@/lib/supabase'
import App from './App.tsx'
import './index.css'

// Set the Supabase client for shared package
setSupabaseClient(supabase)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
